
  var _styles = {
  "team-recommend-bg": {
    "width": "9.36rem",
    "height": "8.96rem",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "paddingTop": "0.28rem",
    "marginTop": 0,
    "marginRight": "0.32rem",
    "marginBottom": 0,
    "marginLeft": "0.32rem",
    "position": "relative"
  },
  "team-recommend-bg-view": {
    "width": "9.36rem",
    "height": "7.88rem",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "paddingTop": "0.28rem",
    "marginTop": 0,
    "marginRight": "0.32rem",
    "marginBottom": 0,
    "marginLeft": "0.32rem",
    "position": "relative",
    "backgroundColor": "rgb(255,255,255)",
    "overflow": "hidden"
  },
  "team-recomment-wrap": {
    "display": "flex",
    "alignItems": "center",
    "position": "relative",
    "height": "7.88rem",
    "marginTop": "0.18667rem"
  },
  "team-recommend-top-actions": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-around",
    "paddingTop": "0.18667rem"
  },
  "team-recommend-top-action-spliter-line": {
    "width": "8.73333rem",
    "height": "0.01067rem",
    "backgroundColor": "rgba(0,0,0,0.06)",
    "marginTop": "0.13333rem"
  },
  "team-recommend-top-actions-item": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "team-recommend-top-actions-text": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "marginLeft": "0.06667rem"
  },
  "team-recommend-list": {
    "marginTop": "0.16rem",
    "overflow": "hidden"
  },
  "team-recommend-item": {
    "width": "9.36rem",
    "height": "1.53333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "paddingTop": "0.29333rem",
    "paddingRight": "0.31333rem",
    "paddingBottom": "0.30667rem",
    "paddingLeft": "0.32667rem",
    "justifyContent": "space-between",
    "position": "relative",
    "marginTop": "0.06667rem"
  },
  "team-recommend-item-left": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "team-info-name-wrap": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "height": "0.53333rem"
  },
  "team-recommend-item-team-name": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.32rem",
    "maxWidth": "2.93333rem",
    "lineHeight": "0.53333rem"
  },
  "team-recommend-item-member-count": {
    "color": "rgb(153,153,153)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "marginLeft": "-0.13333rem",
    "marginRight": "-0.13333rem",
    "lineHeight": "0.53333rem"
  },
  "team-recommend-item-tag": {
    "backgroundColor": "rgb(255,251,224)",
    "borderRadius": "0.10667rem",
    "height": "0.37333rem",
    "paddingTop": "0.05333rem",
    "paddingRight": "0.10667rem",
    "paddingBottom": "0.05333rem",
    "paddingLeft": "0.10667rem"
  },
  "team-recommend-item-tag-text": {
    "color": "rgb(158,117,73)",
    "fontSize": "0.26667rem",
    "fontWeight": "400",
    "fontFamily": "PingFang SC"
  },
  "item-call-wrap": {
    "flexDirection": "row",
    "alignItems": "center",
    "height": "0.48rem"
  },
  "team-recommend-item-call-value": {
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "marginLeft": "0.05333rem",
    "lineHeight": "0.48rem"
  },
  "team-recommend-item-join-button": {
    "width": "1.8rem",
    "height": "0.8rem",
    "borderRadius": "0.8rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "borderWidth": "0.01333rem",
    "borderColor": "rgb(204,204,204)"
  },
  "team-recommend-item-join-button-text": {
    "fontSize": "0.37333rem",
    "fontWeight": "bold",
    "color": "rgb(17,17,17)"
  },
  "team-recommend-list-footer": {
    "position": "absolute",
    "top": "4.21333rem",
    "width": "9.36rem",
    "height": "3.28rem"
  },
  "team-recommend-list-footer-gradient": {
    "height": "0.70667rem",
    "width": "9.36rem",
    "marginBottom": "-0.01333rem"
  },
  "team-recommend-list-footer-image": {
    "height": "1.46667rem",
    "width": "9.36rem",
    "backgroundColor": "rgb(255,255,255)"
  },
  "team-recommend-item-spliter-line": {
    "position": "absolute",
    "bottom": 0,
    "right": "0.31333rem",
    "width": "7.45333rem",
    "height": "0.01067rem",
    "backgroundColor": "rgba(0,0,0,0.06)"
  },
  "team-recommend-list-checkbox": {
    "bottom": 0,
    "left": 0,
    "right": 0,
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "paddingTop": "0.21333rem",
    "paddingBottom": "0.21333rem",
    "backgroundColor": "rgb(255,255,255)"
  },
  "team-recommend-list-checkbox-icon": {
    "width": "0.44rem",
    "height": "0.44rem",
    "borderRadius": "0.44rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "marginRight": "0.10667rem"
  },
  "team-recommend-list-checkbox-text": {
    "fontWeight": "400",
    "color": "rgb(136,136,136)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "zIndex": 1
  },
  "team-recommend-list-cover": {
    "flex": 1,
    "backgroundColor": "rgb(255,255,255)"
  }
};



  module.exports = _styles;
  